import { render, staticRenderFns } from "./lkuItemSaldoLazzyTO.vue?vue&type=template&id=63df7ad8"
import script from "./lkuItemSaldoLazzyTO.vue?vue&type=script&lang=js"
export * from "./lkuItemSaldoLazzyTO.vue?vue&type=script&lang=js"
import style0 from "./lkuItemSaldoLazzyTO.vue?vue&type=style&index=0&id=63df7ad8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports